module.exports = __webpack_public_path__ + "static/media/astral-nav-screenshot-2.1b7c3a82.jpg";